import { FC } from 'react';

import { Box, Skeleton, Stack } from '@mantine/core';

import { useIsMobile } from 'hooks/use-is-mobile';

import cx from './ProjectTeaserHorizontal.module.scss';

export const ProjectTeaserHorizontalSkeleton: FC = () => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return <Skeleton height={100} radius="md" />;
    }

    return (
        <Box className={cx.wrapper}>
            <Box className={cx.inner}>
                <Box className={cx.preview}>
                    <Skeleton w="100%" h="100%" radius={0} />
                </Box>

                <Box className={cx.details}>
                    <Stack gap={8} justify="center">
                        <Skeleton height={18} radius="sm" width="65%" />
                        <Skeleton height={12} radius="sm" width="40%" />
                        <Skeleton height={20} radius="xl" width="30%" mt={4} />
                    </Stack>

                    <Stack gap={6} justify="center">
                        <Skeleton height={20} width={20} radius="xl" />
                        <Skeleton height={12} radius="sm" width="80%" />
                        <Skeleton height={12} radius="sm" width="50%" />
                    </Stack>

                    <Stack gap={4} justify="center">
                        <Skeleton height={12} radius="sm" width="80%" />
                        <Skeleton height={12} radius="sm" width="55%" />
                    </Stack>

                    <Stack gap={4} justify="center">
                        <Skeleton height={12} radius="sm" width="70%" />
                        <Skeleton height={12} radius="sm" width="40%" />
                    </Stack>

                    <Stack gap={4} justify="center">
                        <Skeleton height={28} width={28} radius="xl" />
                    </Stack>
                </Box>
            </Box>
        </Box>
    );
};
